import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    staticClass: "message-box"
  }, [_vm._m(0), _c('div', {
    staticClass: "message-main"
  }, [_c('div', {
    staticClass: "icon-item "
  }, [_c('a-icon', {
    attrs: {
      "type": "loading"
    }
  })], 1), _c('div', {
    staticClass: "message-content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.t('温馨提示')))]), _c('p', [_vm._v(_vm._s(_vm.t('页面加载中，请耐心等待...')))])])])])]);
};

var staticRenderFns = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "message-title"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/logo.png")
    }
  })]);
}];
export { render, staticRenderFns };